import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { CouponType } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Checkout
 * @param coupon
 * @param items
 */
const validateCoupon = (coupon: string, items: any[]): Promise<CouponType> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.PAYMENTS + '/coupon'
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }

    const data = { items, coupon }
    AxiosClient.post(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default validateCoupon
